import React, { useState } from "react";
import siq from "../Image/SIQ 1.png";
import gc from "../Image/gc-logo 1.png";
import ellipse from "../Image/Ellipse 33.png";
import socialicon from "../Image/social-icon.png";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div>
      <footer className="footer">
        <div style={{ borderBottom: "1px solid #2D4B82" }}>
          <div className="container d-grid pt-4 footer-container">
            <div className="footer-column">
              <h4 onClick={() => toggleSection("games")}>
                IN-HOUSE GAME
                <span className="footer-toggle">
                  {openSection === "games" ? "-" : "+"}
                </span>
              </h4>

              <ul className={openSection === "games" ? "show" : ""}>
                <li>Dice</li>
                <li>Slots</li>
                <li>Rank system</li>
                <li>Live casino</li>
                <li>Plinko</li>
                <li>5 Lions Megaways</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 onClick={() => toggleSection("features")}>
                FEATURES
                <span className="footer-toggle">
                  {openSection === "games" ? "-" : "+"}
                </span>
              </h4>

              <ul className={openSection === "features" ? "show" : ""}>
                <li>Staking</li>
                <li>BetFury Box</li>
                <li>Cashback</li>
                <li>Daily tasks</li>
                <li>Affiliate Program</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 onClick={() => toggleSection("about")}>
                ABOUT US
                <span className="footer-toggle">
                  {openSection === "games" ? "-" : "+"}
                </span>
              </h4>

              <ul className={openSection === "about" ? "show" : ""}>
                <li>News</li>
                <li>About BFG</li>
                <li>About team</li>
                <li>BetFury Whitepaper</li>
                <li>BetFury Docs</li>
                <li>Official Mirrors</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 onClick={() => toggleSection("help")}>
                HELP
                <span className="footer-toggle">
                  {openSection === "games" ? "-" : "+"}
                </span>
              </h4>

              <ul className={openSection === "help" ? "show" : ""}>
                <li>Fairness</li>
                <li onClick={() => navigate("/Privacy-Policy")}>
                  Privacy Policy
                </li>
                <li onClick={() => navigate("/terms")}>Terms of Service</li>
                <li>Sportsbetting T&C</li>
                <li>Bug Bounty Program</li>
                <li>Live Support</li>
                <li>Responsible Gambling</li>
              </ul>
            </div>

            <div>
              <div className="d-flex gap-3 align-items-center mb-4 footer-logo">
                <div className="age-badge position-relative">
                  <img src={ellipse} alt="18+" width={40} height={40} />
                  <h4>18+</h4>
                </div>
                <img src={siq} alt="" />
                <img src={gc} alt="" />
              </div>
              <div className="footer-text">
                <p>
                  This website offers gaming with risk experience. To be a user
                  of our site you must be over 18 years old. We are not
                  responsible for the violation of your local laws related to
                  i-gaming. Play responsibly and have fun on BetKing.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container footer-bottom">
          <div className="d-flex align-items-center footer-wrapper">
            <div>
              <p style={{ color: "#4164A7" }} className="mb-0">
                Copyright © 2019-2023 BetKing. All rights reserved.
              </p>
            </div>
            <div>
              <a href="https://www.google.com/" target="_blank">
                <img src={socialicon} alt="" height={39} />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
